import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=fadab768&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=fadab768&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=fadab768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadab768",
  null
  
)

export default component.exports